module.exports = __webpack_public_path__ + "img/inviting-patients-icon-orange.617258e7.svg";